import React, { useState } from 'react';
import './ConfirmExportModalContent.css';
import './ExportExcelModalContent.css';
import ExportProgressOverlay from '../../shared/ExportProgressOverlay';
import { PAGE_SIZE_A4, PAGE_SIZE_A3, PAGE_SIZE_ARCH_D } from '../../../../utilities/constants/pageSizeConstants';
import { resolveModalTask, clearModalTask } from '../modalTaskRegistry';

// Lets user choose how to export PDF: one combined file or separate files
function ConfirmExportPdfModalContent({ onClose, taskId, pageSize }) {
  const [exporting, setExporting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [mode, setMode] = useState('combined'); // 'combined' | 'separate'
  const [status, setStatus] = useState('running');
  const [exportError, setExportError] = useState('');

  const sizeLabel = (ps) => {
    switch (ps) {
      case PAGE_SIZE_A4: return 'A4';
      case PAGE_SIZE_A3: return 'A3';
      case PAGE_SIZE_ARCH_D: return 'Arch D';
      default: return String(ps || 'A4');
    }
  };

  const handleConfirm = async () => {
    const task = taskId ? resolveModalTask(taskId) : null;
    if (!task) {
      console.error('[ConfirmExportPdfModalContent] No task registered for id', taskId);
      setExporting(true);
      setStatus('error');
      setExportError('No se pudo iniciar la exportación PDF.');
      return;
    }
    setExporting(true);
    setStatus('running');
    setExportError('');
    setProgress(0);
    try {
      await task(setProgress, { mode });
      setProgress(100);
      setStatus('success');
      setTimeout(onClose, 500);
    } catch (error) {
      console.error('[ConfirmExportPdfModalContent] Export failed', error);
      setStatus('error');
      setExportError(error?.message || 'No se pudo completar la exportación PDF.');
    } finally {
      clearModalTask(taskId);
    }
  };

  return (
    <div className="excel-modal__content">
      {!exporting ? (
        <>
          <div className="excel-modal__title">Exportar PDF</div>
          <div className="excel-modal__subtitle">Exportar en formato PDF con tamaño {sizeLabel(pageSize)}</div>
          <div className="excel-modal__checkbox-group" style={{ marginTop: 6 }}>
            <label className="excel-modal__checkbox-label">
              <input
                className="excel-modal__checkbox-input"
                type="radio"
                name="pdfmode"
                value="combined"
                checked={mode === 'combined'}
                onChange={() => setMode('combined')}
              />
              <span>Un solo PDF (varias páginas)</span>
            </label>
            <label className="excel-modal__checkbox-label">
              <input
                className="excel-modal__checkbox-input"
                type="radio"
                name="pdfmode"
                value="separate"
                checked={mode === 'separate'}
                onChange={() => setMode('separate')}
              />
              <span>PDFs separados (una página por archivo)</span>
            </label>
          </div>
          <div className="excel-modal__actions">
            <button className="excel-modal__button excel-modal__button--cancel" onClick={onClose}>Cancelar</button>
            <button className="excel-modal__button excel-modal__button--export" onClick={handleConfirm}>Exportar</button>
          </div>
        </>
      ) : (
        <ExportProgressOverlay
          progress={progress}
          status={status}
          error={exportError}
          message="Exportando PDF"
          onClose={onClose}
        />
      )}
    </div>
  );
}

export default ConfirmExportPdfModalContent;
